import { z } from 'zod'

import type { MapItem } from 'src/shared/schemas/utils'

export const rentalTypeMap: Record<RentalType, MapItem> = {
  apartment: { label: 'Apartment' },
  condo: { label: 'Condo' },
  house: { label: 'House' },
  townhouse: { label: 'Townhouse' },
  room: { label: 'Room in shared housing' },
  commercial: { label: 'Commercial' },
  other: { label: 'Other' },
}

export const rentalTypeSchema = z.enum(Object.keys(rentalTypeMap) as [RentalType, ...RentalType[]])

export type RentalType = 'apartment' | 'condo' | 'house' | 'townhouse' | 'room' | 'commercial' | 'other'
